export default __webpack_public_path__ + "static/media/selecta_medium.7ade683f.jpg";